<template>
	<v-container fluid ml-2 mr-2>
		<v-dialog v-model="showCreateFolder" max-width="500px">
			<CreateNewsletterFolderDialog
				@close-dialog="randomizer = Math.random(); showCreateFolder = false; refreshImages()" />
		</v-dialog>
		<v-alert :value="checkingForImages" type="info">
			Checking to see what images you have already uploaded...
		</v-alert>
		<div v-if="!checkingForImages">
			<v-alert type="info">
				As a newsletter volunteer, this portal is where you upload images for consideration in {{ longDate }}'s
				newsletter. You may upload JPEG, text, and Word files.</v-alert>

			<DropUpload :newsletterFolder="$route.query.folder" uploadWhere="newsletter_assets" @uploadComplete='refreshImages' :transparent=false
				:clickable=true :maxFiles=20 :date=$route.params.newsletterID
				acceptedFiles="application/*,image/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,image/png,application/pdf">
				<div class="dropzone-custom-content elevation-5">
					<v-icon large>cloud_upload</v-icon>
					<h3 class="dropzone-custom-title">Click to select files from your computer. JPEG files will be
						scaled
						down to 1024x1024 pixels, to make them easier to include in the newsletter</h3>
					<div class="subtitle">...or drag and drop files here...</div>
				</div>
			</DropUpload>
			<div v-if="this.$route.query.folder != undefined">
				You are inside folder <b>{{ this.$route.query.folder }}</b> of newsletter <b>{{
					this.$route.params.newsletterID }}</b> &nbsp;
				<a :href="'/#/newslettershare/' + this.$route.params.newsletterID">Go back to top newsletter folder</a>
			</div>
			<v-btn class="mb-5" v-if="$store.state.roles.includes('newsletter') && (this.$route.query.folder == undefined)" color="success"
				@click="download()">Download all {{
					sortedPhotos.length }} newsletter assets</v-btn>
			<v-btn class="mb-5 ml-5" v-if="$store.state.roles.includes('newsletter') && (this.$route.query.folder == undefined)" color="success"
				@click="createFolder()">Create Folder</v-btn>
		</div>
		<v-container v-if="checkingForImages" text-center>
			<v-progress-circular class="text-center" indeterminate color="primary"></v-progress-circular>
		</v-container>
		<v-card v-if="$store.state.roles.includes('newsletter')">
			<v-layout row wrap ml-2 mt-2>
				<v-flex v-for="(photo) in sortedPhotos" :key="photo.name" pa-1>
					<div v-if="photo.isDir">
						<a :href="'/#/newslettershare/' + $route.params.newsletterID + '?folder=' + photo.name">
							<v-layout column align-center>
								<img width="100" src="https://nc-photo.org/res/HP-Pictures-Folder-icon.png" />
								{{ photo.name }}
							</v-layout>
						</a>
					</div>
					<v-card v-else="!photo.isDir" class="elevation-10" width="220" color="#EEEEEE">
						<v-layout column>
							<div>
								<a :href="website + '/newsletter/' + $route.params.newsletterID + '/assets/' + ($route.query.folder ? $route.query.folder + '/' : '') + photo.name"
									target="_new">
									<img v-if="photo.name.includes('.pages') || photo.name.includes('.doc') || photo.name.includes('.txt')"
										src="https://1000logos.net/wp-content/uploads/2020/08/Microsoft-Word-Logo-500x281.png"
										width="200" />
									<v-img
										:src="website + '/newsletter/' + $route.params.newsletterID + '/assets/' + ($route.query.folder ? $route.query.folder + '/' : '') + photo.name"
										class="imgthumb" min-width="200" />
								</a>
							</div>
						</v-layout>
						<a :href="website + '/newsletter/' + $route.params.newsletterID + '/assets/' + ($route.query.folder ? $route.query.folder + '/' : '') + photo.name"
							target="_new">
							{{ photo.name }}
						</a>
					</v-card>
				</v-flex>
			</v-layout>
		</v-card>
	</v-container>
</template>

<script>
import DropUpload from '@/components/DropUpload'
import { TokenService } from '@/services/storage.service'
import axios from 'axios'
import { format, parseISO } from 'date-fns'
import CreateNewsletterFolderDialog from '@/components/CreateNewsletterFolderDialog'

export default {
	components: {
		DropUpload,
		CreateNewsletterFolderDialog
	},
	watch: {
		'$refs.upload'() {
			this.refreshImages()
		},
		'$route.query.folder'() {
			this.refreshImages()
		}
	},
	created() {
		// alert(this.$route.params.newsletterID+':'+this.$route.query.folder)
		this.loadNewsletterFiles(this.$route.params.newsletterID)
		this.token = TokenService.getToken()
		this.username = TokenService.getUsername()
	},
	computed: {
		website: function () {
			return process.env.VUE_APP_WEBSITE
		},
		sortedPhotos: function () {
			function compare(a, b) {
				if (a.name < b.name) {
					return -1
				}
				if (a.name > b.name) {
					return 1
				}
				return 0
			}
			return this.photos.sort(compare)
		},
	},
	data() {
		return {
			memberShareImages: [],
			photos: [],
			checkingForImages: true,
			memberShareDesc: '',
			memberShareTitle: '',
			month: '',
			longDate: format(parseISO(this.$route.params.newsletterID), 'MMMM yyyy', new Date()),
			files: [],
			token: '',
			username: '',
			showConfirmation: false,
			showCreateFolder: false
		}
	},

	methods: {
		refreshImages() {
			this.loadNewsletterFiles(this.$route.params.newsletterID)
		},
		download() {
			window.open(process.env.VUE_APP_WEBSITE + '/newsletter/download_newsletter_assets.php?newsletterID=' + this.$route.params.newsletterID, '_new')
		},
		createFolder() {
			this.showCreateFolder = true;
		},

		loadNewsletterFiles(newsletterID) {
			this.checkingForImages = true
			var directory = newsletterID + '/assets'
			if (this.$route.query.folder != undefined) {
				directory += '/' + this.$route.query.folder
			}
			axios({
				method: 'GET',
				'url': process.env.VUE_APP_WEBSITE + '/memberlogin2/api_listfiles.php',
				params: {
					'Username': TokenService.getUsername(),
					'token': TokenService.getToken(),
					'newsletter_dir': directory,
				}
			}).then(result => {
				this.photos = []
				result.data.forEach(element => {
					this.photos.push(element)
				})
				this.checkingForImages = false
			}, error => {
				this.photos = []
				console.error(error)
			})
		},
	}
}
</script>

<style scoped>
.imgthumb {
	border: 1px solid #aaaaaa;
	max-width: 130px;
	max-height: 130px;
}

.my-text-style>>>.v-text-field__slot input {
	position: absolute;
	bottom: 9px;
	color: white;
}
</style>
